import React from "react";

export class Canvas extends React.Component {
    constructor(props) {
        super(props);

        this.drawImage = this.drawImage.bind(this);
    }

    componentDidMount() {
        setTimeout(() => {
            this.drawImage();
        }, 200);
    }

    drawImage() {
        // draw the image
        if(this.props.open) {
            var canvas = document.getElementById(this.props.name),
                ctx = canvas.getContext("2d");
                
            
            // clear
            ctx.clearRect(0, 0, this.props.side, this.props.side);


            // draw all layers
            var images = this.props.layers.slice(0).reverse().map((layer, i) => {
//                console.log(layer);
                var img = document.createElement("img");
                img.src = "./img/" + layer.section + "/" + layer.item + ".png";
                
                // store cheeky attributes in here
                img.setAttribute("data-xOffset", layer.xOffset);
                img.setAttribute("data-yOffset", layer.yOffset);
                img.setAttribute("data-rotation", layer.rotation);
                img.setAttribute("data-scale", layer.scale);
                img.setAttribute("data-hFlip", layer.hFlip);
                img.setAttribute("data-vFlip", layer.vFlip);
                img.setAttribute("data-side", this.props.side);
                img.setAttribute("data-index", i);
                
                return img;
            });

            Promise.all(images.map((image) => {
                return new Promise((resolve, reject) => {
                    image.onload = resolve;
                });
            }))
            .then(() => {
                // once they're all loaded
                for(var i = 0; i < images.length; i++) {
                    var img = images[i];

                    if(i == img.getAttribute("data-index")) {
                        // set
                        ctx.rotate(img.getAttribute("data-rotation") * (Math.PI / 180) * -1);
    
                            // flip
                        var xMod = 1, yMod = 1;
    
                        if(img.getAttribute("data-hFlip")) {
                            xMod = -1;
                        }
    
                        if(img.getAttribute("data-vFlip")) {
                            yMod = -1;
                        }
    
                        ctx.scale(img.getAttribute("data-scale") * xMod, img.getAttribute("data-scale") * yMod);
    
                        
                        // draw
                        ctx.drawImage(
                            img, 0, 0, img.getAttribute("data-side"), img.getAttribute("data-side"),
                            img.getAttribute("data-xOffset"), img.getAttribute("data-yOffset"),
                            img.getAttribute("data-side") * img.getAttribute("data-scale"), img.getAttribute("data-side") * img.getAttribute("data-scale"),
                        );
                        
    
                        // reset
                        ctx.rotate(img.getAttribute("data-rotation") * (Math.PI / 180));
    
                        ctx.scale(img.getAttribute("data-scale") * -xMod, img.getAttribute("data-scale") * -yMod);

                    }
                }
            });

        }
    }

    render() {
        return (
            <div className="canvas-container">
                <canvas width={this.props.side} height={this.props.side} id={this.props.name} onClick={this.drawImage}></canvas>

                <span>{this.props.side}px</span>
            </div>
        );
    }
}


Canvas.defaultProps = {
    open: false
};
